export const environment = {
  base_url: 'https://wa3i.moddakir.com/',
  api_prefix: 'v1/api/',
  api_prefix_Server2: 'v1/api/',
  white_listed_Domains: ['wa3i.moddakir.com'],
  production: true,
  domain: 'https://moddakir.com',
  // firebase
  firebase_url: 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyAqggoW1f_KW9RCBegeFRLUi3_Nr4fJICM',
  firebase: {
    apiKey: 'AIzaSyB93ABACat8EF7WSU0JFmSYvHk1D7abFrk',
    authDomain: 'moddakir-saas.firebaseapp.com',
    projectId: 'moddakir-saas',
    messagingSenderId: '115526362096',
    appId: '1:115526362096:web:4e94ca8e54adb3e6177335',
    measurementId: 'G-8SHVQQZFVN',
  },
};
